export const SidebarContainerStyle = {
  root: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflow: "hidden",
  },
  sidebar: {
    zIndex: 2000,
    position: "absolute",
    top: 0,
    bottom: 0,
    transition: "transform .3s ease-out",
    WebkitTransition: "-webkit-transform .3s ease-out",
    willChange: "transform",
    overflowY: "auto",
    overflowX: "hidden",
    width: "316px",
    cursor: "pointer",
    // padding: '20px',
    // background: "#9fc44e",
    // background: 'rgb(255,255,255)',
    // background: 'linear-gradient(190deg, rgba(159,196,78,1) 0%, rgba(255,255,255,1) 35%)'
    // background: 'linear-gradient(rgba(159,196,78,1), rgba(255,255,255,1))'
    backgroundImage:
      "linear-gradient(to left bottom, rgb(156, 176, 109), rgb(163, 182, 117), rgb(169, 187, 126), rgb(176, 193, 134), rgb(183, 199, 143), rgb(189, 204, 152), rgb(196, 210, 161), rgb(202, 215, 170), rgb(210, 221, 182), rgb(218, 226, 194), rgb(225, 232, 207), rgb(233, 238, 219))",
  },
  content: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflowY: "auto",
    WebkitOverflowScrolling: "touch",
    transition: "left .3s ease-out, right .3s ease-out",
  },
  overlay: {
    zIndex: 1000,
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    opacity: 0,
    visibility: "hidden",
    transition: "opacity .3s ease-out, visibility .3s ease-out",
    backgroundColor: "rgba(0,0,0,.3)",
    // backgroundColor: "#9cb06d"
  },
  dragHandle: {
    zIndex: 1,
    position: "fixed",
    top: 0,
    bottom: 0,
  },
};
